var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},[_vm._m(0),_vm._l((_vm.projects),function(project){return _c('project-item',{key:project.id,attrs:{"project":project}})})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid"},[_c('h3',[_vm._v("Prosjekt")]),_c('h3',[_vm._v("Kritiske feil")]),_c('h3',[_vm._v("Nye feil")]),_c('h3',[_vm._v("Nye oppgaver")]),_c('h3',{staticClass:"titles"},[_vm._v("Alternativer")])])
}]

export { render, staticRenderFns }